
import { Navigate, useLocation } from "react-router-dom";
import {APP_WEB_SITE} from "@/electron_interactive";

function Guard({ Cmp, ...props }) {
    if (APP_WEB_SITE){
        // console.log('Cmp', Cmp, props);
        const { pathname } = useLocation();
        /* const { user } = useSelector(state => state);
        const dispatch = useDispatch();
        useEffect(() => {
            // 若没有用户信息,保存现在的地址
            if (!user) {
                dispatch({
                    type: 'prevPath',
                    prevPath: pathname
                })

            }
        }, [user]) */
        // 若有用户信息正常展示组件，若没有跳转到登录页
        console.log(pathname);
        localStorage.setItem('pathname',pathname)
        //根据需求处理获取到的当前的路由信息
        let pathnameArr = pathname.split('/').filter(path=>path!==''&&path!=='*')
        console.log(pathnameArr);
        let path = pathnameArr[pathnameArr.length-1]
        console.log(path);

        //函数用于验证当前路由是否合法，否则返回false,并跳转到404页面
        function validPath(){
            let flag = true;


            return flag
        }
        let _token= localStorage.getItem('access_token')
        // 获取路由与menu 的path 匹配
        return _token? (validPath()? <Cmp {...props} />:<Navigate to="/404" />):<Navigate to="/login" />
    }
    return <Cmp {...props} />;
}

// 一个高阶函数,将组件和props都传递给函数组件Guard
export default function withGuard(Cmp:any) {
    return (props:any) => <Guard Cmp={Cmp} {...props} />
}